import IconHome from './iconhome';

export default IconHome;